import { isJSON } from '@st/utils-js';
import { validate } from '../utils/uuid';
import ElementAttrs from './ElementAttrs';
import UserRolle from './enums/UserRolle';
import Responsibilities from './Responsibilities';

const REQUIRED_ROLES = [UserRolle.RECHTSANWALT, UserRolle.PARTNER, UserRolle.ADMINPARTNER];

export default class UeberschriftKlauselTransformationCheckliste extends ElementAttrs {
  /**
   *
   * @param {String} name
   * @param {Array} hashtags Array of UUIDs
   * @param {Responsibilities} responsibilities
   */
  constructor(name = '', hashtags = [], responsibilities = new Responsibilities()) {
    super(name, hashtags, responsibilities, REQUIRED_ROLES);
  }

  /**
   * Creates UeberschriftKlauselTransformationCheckliste from JSON.
   * If keys are missing then it will use the default values.
   * @param {JSON} value
   * @returns null if invalid
   */
  static fromJSON(value) {
    if (!isJSON(value)) return null;

    const { name = '', hashtags = [], responsibilities = new Responsibilities() } = value;

    let res = responsibilities;
    if (!(res instanceof Responsibilities) && isJSON(res)) {
      res = Responsibilities.fromJSON(res);
    }

    return new UeberschriftKlauselTransformationCheckliste(name, hashtags, res);
  }

  /**
   * @returns UeberschriftKlauselTransformationCheckliste in JSON representation
   */
  toJSON() {
    let responsibilities = {};
    if (this.responsibilities instanceof Responsibilities) {
      responsibilities = this.responsibilities.toJSON();
    } else {
      responsibilities = this.responsibilities;
    }

    return {
      name: this.name,
      hashtags: this.hashtags,
      responsibilities,
    };
  }

  get validResponsibilities() {
    return (
      !!this.responsibilities &&
      this.responsibilities instanceof Responsibilities &&
      validate(this.responsibilities[UserRolle.RECHTSANWALT]) &&
      validate(this.responsibilities[UserRolle.ADMINPARTNER]) &&
      validate(this.responsibilities[UserRolle.PARTNER]) &&
      !this.responsibilities[UserRolle.PRODUKTKOORDINATOR] &&
      !this.responsibilities[UserRolle.MANDANT] &&
      !this.responsibilities[UserRolle.SACHBEARBEITER]
    );
  }

  get valid() {
    const { validName, validHashtags, validResponsibilities } = this;

    const valid = validName && validHashtags && validResponsibilities;
    return valid;
  }
}
